module.exports = __webpack_public_path__ + "img/task.8647f09c.svg";